import { ReactNode } from 'react';
import { useGlobalComponentsContext } from 'src/contexts/GlobalComponentsContext';
import Drawer from '@mui/material/Drawer';
import { useTheme } from '@mui/material/styles';

export type OpenDrawerSettings = {
  children?: ReactNode;
  onClose?: () => void;
};

export function useDrawer(id: string) {
  const { union, remove } = useGlobalComponentsContext();
  const theme = useTheme();

  return {
    open: ({ children, ...props }: OpenDrawerSettings) => {
      union(
        id,
        <Drawer
          open={true}
          anchor="right"
          PaperProps={{
            sx: {
              background: theme.palette.background.elevation[8],
              backdropFilter: theme.glass[8],
              p: 8,
              maxWidth: 600,
            },
          }}
          {...props}
          onClose={() => {
            remove(id);
            if (!!props.onClose) {
              props.onClose();
            }
          }}
        >
          {children}
        </Drawer>,
      );
    },
    close: () => {
      remove(id);
    },
  };
}
